import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  "/": "Orion Security – Istituto di vigilanza privata dal 1992",
  "/servizi": "Servizi di vigilanza armata e non armata | Orion Security",
  "/preventivo": "Preventivo gratuito in un minuto | Orion Security",
  "/centrale-operativa": "Centrale operativa e pronto intervento H24 | Orion Security",
  "/obiettivi-sensibili": "Obiettivi sensibili: aeroporti, porti, stazioni | Orion Security",
  "/chi-siamo": "Chi siamo: istituto di vigilanza dal 1992 | Orion Security",
  "/contatti": "Contatti e preventivo gratuito | Orion Security",
  "/privacy": "Privacy Policy | Orion Security",
  "/cookie": "Cookie Policy | Orion Security",
  "/accessibilita": "Dichiarazione di accessibilità | Orion Security",
  "/whistleblowing": "Whistleblowing | Orion Security",
};

function setRobots(content) {
  let m = document.querySelector('meta[name="robots"]');
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute("name", "robots");
    document.head.appendChild(m);
  }
  m.setAttribute("content", content);
}

export function MetaTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    setRobots("index,follow");
    if (pathname.startsWith("/servizi/")) {
      document.title = "Servizio di vigilanza | Orion Security";
      return;
    }
    document.title = TITLES[pathname] || TITLES["/"];
  }, [pathname]);
  return null;
}
